import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SeoJsonLd from "@/components/feature/SeoJsonLd";
import { SITE_URL } from "@/constants/site";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import WhatIsSection from "./components/WhatIsSection";
import WhyChooseSection from "./components/WhyChooseSection";
import ComparisonHub from "./components/ComparisonHub";
import SafetySection from "./components/SafetySection";
import ArticleCTA from "./components/ArticleCTA";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "name": "Hipobuy Spreadsheet",
      "url": SITE_URL,
      "description": "The ultimate product research database and shopping intelligence hub. Discover organized product resources, comparison tables, shopping guides, and buyer information.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": SITE_URL + "/?search={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "name": "Hipobuy Spreadsheet",
      "url": SITE_URL,
      "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg",
      "description": "The ultimate product research database and shopping intelligence hub for smart online shoppers.",
      "sameAs": [
        "https://kaspreadsheet.com"
      ]
    }
  ]
};

export default function Home() {
  return (
    <>
      <SeoJsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhatIsSection />
        <WhyChooseSection />
        <ComparisonHub />
        <SafetySection />
        <ArticleCTA />
      </main>
      <Footer />
    </>
  );
}